var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHltVCms03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1139 5.38438C11.5285 6.69404 8.78825 9.75923 7.9341 13.5404C3.99805 13.8431 0.898438 17.1296 0.898438 21.1429C0.898438 25.3557 4.3134 28.7715 8.52617 28.7715H19.9516V23.5983H16.1117L22.991 16.2401L29.8704 23.5983H26.0484V28.7715H38.8952C42.3227 28.7715 45.1016 25.9927 45.1016 22.5642C45.1016 19.1367 42.3227 16.3578 38.8952 16.3578C38.6921 16.3578 38.4918 16.3686 38.2941 16.3875C36.9815 12.9608 33.6618 10.5269 29.7733 10.5269C29.4966 10.5269 29.2235 10.5413 28.9539 10.5656C27.6332 8.17789 25.4771 6.31696 22.8804 5.37549",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.97998 35.9969H12.8532C16.7739 35.9969 19.9517 32.8191 19.9517 28.8992V23.5984H16.1118L22.9911 16.2402L29.8705 23.5984H26.0485V28.8992C26.0485 32.8191 29.2263 35.9969 33.1471 35.9969H38.6665",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6665 41.3022H31.6098C28.2732 41.3022 25.0103 39.6782 23.0001 37.0139C20.9775 39.6816 17.7403 41.3022 14.3886 41.3022H6.97998",
    stroke: "#457ABD",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHltVCms03);
export default __webpack_public_path__ + "static/media/HLT-vCMS03.98ed4e2da7876790882bbd3ed08261e8.svg";
export { ForwardRef as ReactComponent };